import {
  ClinicalOutreachConversation,
  ClinicalVisitConversation,
  DeleteClinicalDataElementsRequest,
} from "@/api/generated/models";
import { ScrollView, YStack } from "@/components";
import SettingsListItem from "../SettingsListItem";

type ClinicalDataElements = (
  | (ClinicalOutreachConversation & { type: "outreach" })
  | (ClinicalVisitConversation & { type: "visit" })
)[];

interface DataPrivacyListProps {
  clinicalDataElements: ClinicalDataElements;
  handleSelect: (payload: DeleteClinicalDataElementsRequest) => void;
}

export default function DataPrivacyList({
  clinicalDataElements,
  handleSelect,
}: DataPrivacyListProps) {
  return (
    <ScrollView flex={1}>
      <YStack gap="$150">
        {clinicalDataElements.map((clinicalDataElement) => {
          const headerText =
            clinicalDataElement.type === "visit"
              ? "Clinic visit and visit data"
              : "Outreach from Curai";
          const isDisabled =
            clinicalDataElement.type === "visit"
              ? !clinicalDataElement.closed
              : false;
          const formattedDate = new Date(
            clinicalDataElement.created_at,
          ).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
          return (
            <SettingsListItem
              key={clinicalDataElement.id}
              title={headerText}
              subtitle={formattedDate}
              onDelete={() => {
                if (clinicalDataElement.type === "visit") {
                  handleSelect({
                    visit_conversation_ids: [clinicalDataElement.id],
                    outreach_conversation_ids: [],
                  });
                } else {
                  handleSelect({
                    visit_conversation_ids: [],
                    outreach_conversation_ids: [clinicalDataElement.id],
                  });
                }
              }}
              disabled={isDisabled}
            />
          );
        })}
      </YStack>
    </ScrollView>
  );
}
